import { View, Text, Image, StyleSheet } from "@react-pdf/renderer";

import increaseIcon from "assets/img/report-arrow-increase.png";
import decreaseIcon from "assets/img/report-arrow-decrease.png";

import { ReportItemType } from "types/Reports";
import { REPORT_SENSOR_REGISTRY } from "constant/report";

import { formatValuePercentInReport } from "../report/utils/reportFormat";
import { getPercentDirection, getPercentSubText } from "../report/utils/reportString";

const overallPercentTextStyles = StyleSheet.create({
    container: {
        width: '100%',
        position: 'relative',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        marginTop: 10,
    },
    image: {
        position: 'relative',
        width: 16,
        height: 16,
    },
    percent: {
        position: 'relative',
        fontFamily: 'Roboto',
        fontSize: 10,
        fontWeight: 400,
        color: '#333333',
        marginLeft: 3,
    },
    description: {
        position: 'relative',
        fontFamily: 'Roboto',
        fontSize: 10,
        fontWeight: 400,
        color: '#636363',
        marginLeft: 3,
    },
});

type ReportPDFOverallPercentTextProps = {
    percent: number;
    itemType: ReportItemType;
}

const ReportPDFOverallPercentText = ({
    percent,
    itemType,
}: ReportPDFOverallPercentTextProps) => {
    const direction = getPercentDirection(percent);
    const percentIconSource = percent > 0 ? increaseIcon : decreaseIcon;

    const subject = REPORT_SENSOR_REGISTRY[itemType].percentSubject;
    const increaseText = itemType === 'waterLeakage' ? '' : `${subject} ${direction} by`;
    const subText = getPercentSubText(itemType, direction);

    return (
        <View style={overallPercentTextStyles.container}>
            <Image
                style={overallPercentTextStyles.image}
                src={percentIconSource}
            />
            <Text style={overallPercentTextStyles.description}>
                {increaseText}
            </Text>
            <Text style={overallPercentTextStyles.percent}>
                {`${formatValuePercentInReport(percent)}%`}
            </Text>
            <Text style={overallPercentTextStyles.description}>
                {subText}
            </Text>
        </View>
    );
};

export default ReportPDFOverallPercentText;
